"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalHeader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _isReactFragment = require("../utils/isReactFragment");
var _clamp = require("../utils/_clamp");
var _IconButton = require("../IconButton/IconButton");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _messages = require("../utils/messages");
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _Modal = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal.css") : void 0);
const _excluded = ["closeLabel", "closeButton", "className", "children", "customBackAction", "customCloseAction", "draggable", "titleId", "subheadId", "onHide", "updateStyle", "containerRef", "modalContentId"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const CSS_BLOCK = 'sapcnqr-modal';
const MOVEMENT_STEP_SIZE = 16;
const ModalHeader = exports.ModalHeader = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      closeLabel,
      closeButton = false,
      className,
      children,
      customBackAction,
      customCloseAction,
      draggable,
      titleId,
      subheadId,
      onHide,
      updateStyle,
      containerRef,
      modalContentId
    } = props,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  const classnames = _bind.default.bind(_Modal.default);
  const instructionsId = (0, _useUniqueId.default)();
  const [isDragging, setIsDragging] = (0, _react.useState)(false);
  const [position, setPosition] = (0, _react.useState)({
    startX: 0,
    startY: 0,
    x: 0,
    y: 0,
    pageX: 0
  });
  const dialogClientRect = containerRef?.current?.getBoundingClientRect();
  const getDialogNode = () => document?.getElementById(modalContentId);
  const contentClientRect = () => getDialogNode()?.getBoundingClientRect();
  const titleRef = (0, _react.useRef)();
  const subHeadRef = (0, _react.useRef)();
  const getContentTop = () => contentClientRect()?.top || 0;
  const getContentBottom = () => contentClientRect()?.bottom || 0;
  const getContentLeft = () => contentClientRect()?.left || 0;
  const getContentRight = () => contentClientRect()?.right || 0;
  const getContentWidth = () => contentClientRect()?.width || 0;
  const getContentX = () => contentClientRect()?.x || 0;
  const onMouseDown = (0, _react.useCallback)(e => {
    e?.persist?.();
    if (e.button !== 0 || titleRef?.current?.contains(e.target) || subHeadRef?.current?.contains(e.target)) {
      return;
    }
    if (typeof draggable?.onDragStart === 'function') {
      draggable.onDragStart(e);
    }
    setIsDragging(true);
    setPosition(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      startX: e.pageX - prevState.x,
      startY: e.clientY - prevState.y,
      startLeft: containerRef?.current && parseInt(window.getComputedStyle(containerRef.current).getPropertyValue('left').replace('px', ''), 10),
      startLeftEdge: getContentX(),
      startRightEdge: getContentX() + getContentWidth(),
      pageX: e.pageX,
      clientY: e.clientY
    }));
  });
  const onKeyDown = (0, _react.useCallback)(e => {
    e?.persist?.();
    const moveStepSize = e.shiftKey ? 5 * MOVEMENT_STEP_SIZE : MOVEMENT_STEP_SIZE;
    switch (e.keyCode) {
      case _keycode.default.codes.left:
        e.preventDefault();
        if (getContentLeft() > 0) {
          setPosition(prevState => {
            const newLeft = prevState.x - Math.min(moveStepSize, getContentLeft());
            updateStyle?.({
              top: `${prevState.y}px`,
              left: `${newLeft}px`
            });
            return _objectSpread(_objectSpread({}, prevState), {}, {
              x: newLeft
            });
          });
        }
        break;
      case _keycode.default.codes.right:
        e.preventDefault();
        if (getContentRight() < window.innerWidth) {
          setPosition(prevState => {
            const newLeft = prevState.x + Math.min(moveStepSize, window.innerWidth - getContentRight());
            updateStyle?.({
              top: `${prevState.y}px`,
              left: `${newLeft}px`
            });
            return _objectSpread(_objectSpread({}, prevState), {}, {
              x: newLeft
            });
          });
        }
        break;
      case _keycode.default.codes.up:
        e.preventDefault();
        if (getContentTop() > 0) {
          setPosition(prevState => {
            const newTop = prevState.y - Math.min(moveStepSize, getContentTop());
            updateStyle?.({
              top: `${newTop}px`,
              left: `${prevState.x}px`
            });
            return _objectSpread(_objectSpread({}, prevState), {}, {
              y: newTop
            });
          });
        }
        break;
      case _keycode.default.codes.down:
        e.preventDefault();
        if (getContentBottom() < window.innerHeight) {
          setPosition(prevState => {
            const newTop = prevState.y + Math.min(moveStepSize, window.innerHeight - getContentBottom());
            updateStyle?.({
              top: `${newTop}px`,
              left: `${prevState.x}px`
            });
            return _objectSpread(_objectSpread({}, prevState), {}, {
              y: newTop
            });
          });
        }
        break;
      default:
    }
    if (typeof draggable?.onKeyDown === 'function') {
      draggable.onKeyDown(e);
    }
  });
  (0, _useUniversalLayoutEffect.default)(() => {
    // set default vertical positioning
    // needs delay due to fade in .3s transition
    const positioningTimer = setTimeout(() => {
      setPosition(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
        y: containerRef?.current?.getBoundingClientRect()?.top
      }));
    }, 300);
    return () => {
      clearTimeout(positioningTimer);
    };
  }, []);
  (0, _react.useEffect)(() => {
    const onMouseMove = e => {
      e?.persist?.();
      let xDisplacement = e.pageX - position.pageX;
      let yDisplacement = e.clientY - position.startY;
      xDisplacement = (0, _clamp.clamp)(xDisplacement, -position.startLeftEdge, window.innerWidth - position.startRightEdge);
      yDisplacement = (0, _clamp.clamp)(yDisplacement, 0, window.innerHeight - dialogClientRect.height);
      const startLeft = position.startLeft + xDisplacement;
      updateStyle?.({
        top: `${yDisplacement}px`,
        left: `${startLeft}px`
      });
      setPosition(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
        x: startLeft,
        y: yDisplacement,
        pageX: e.pageX,
        clientY: e.clientY,
        startLeft
      }));
    };
    const onMouseUp = e => {
      e?.persist?.();
      setIsDragging(false);
      if (typeof draggable?.onDragEnd === 'function') {
        draggable.onDragEnd(e);
      }
    };
    if (isDragging) {
      document.addEventListener('mouseup', onMouseUp);
      document.addEventListener('mousemove', onMouseMove);
    }
    return () => {
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('mousemove', onMouseMove);
    };
  }, [isDragging]);
  (0, _react.useEffect)(() => {
    if (!draggable) return () => {};
    // try to keep the modal within the window when
    // window resizes

    const handleWindowResize = () => {
      if (!containerRef?.current) {
        return;
      }
      let skipLeftMovement;
      if (getContentWidth() >= window.innerWidth && getContentLeft() <= 0) {
        skipLeftMovement = true;
      }
      let newLeft = parseInt(window.getComputedStyle(containerRef.current).getPropertyValue('left').replace('px', ''), 10);
      let newTop = parseInt(window.getComputedStyle(containerRef.current).getPropertyValue('top').replace('px', ''), 10);
      if (window.innerWidth <= getContentRight() && getContentLeft() > 0) {
        newLeft -= getContentRight() - window.innerWidth;
      } else if (getContentLeft() < 0) {
        newLeft -= getContentLeft();
      }
      if (window.innerHeight <= getContentBottom() && getContentTop() > 0) {
        newTop -= getContentBottom() - window.innerHeight;
      }
      setPosition(prevState => {
        updateStyle?.({
          left: `${skipLeftMovement ? prevState.left : newLeft}px`,
          top: `${newTop}px`
        });
        return _objectSpread(_objectSpread({}, prevState), {}, {
          x: newLeft,
          y: newTop
        });
      });
    };
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [draggable]);
  const headerClasses = classnames(`${CSS_BLOCK}__header`, {
    [`${CSS_BLOCK}__header--draggable`]: draggable,
    [`${CSS_BLOCK}__header--dragging`]: isDragging
  }, className);
  const _renderChildren = childNodes => _react.default.Children.map(childNodes, child => {
    if ((0, _isReactFragment.isReactFragment)(child)) {
      return _renderChildren(child.props.children);
    }
    if (child?.type?.displayName === 'Modal.Title') {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        id: titleId,
        ref: child.ref ? (0, _reactMergeRefs.default)([titleRef, child.ref]) : titleRef
      });
    }
    if (child?.type?.displayName === 'Modal.Subhead') {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        id: subheadId,
        ref: child.ref ? (0, _reactMergeRefs.default)([subHeadRef, child.ref]) : subHeadRef
      });
    }
    return child;
  });
  const additionalProps = draggable ? _objectSpread(_objectSpread({}, otherProps), {}, {
    onMouseDown,
    onKeyDown,
    role: 'button',
    tabIndex: '0',
    'aria-describedby': instructionsId
  }) : otherProps;
  const closeButtonToRender = customCloseAction || closeButton && /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
    ariaLabel: closeLabel,
    className: classnames(`${CSS_BLOCK}__close`),
    iconName: "close",
    iconProps: {
      forceSize: 'xs-plus'
    },
    muted: true,
    onClick: onHide
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, additionalProps, {
    className: headerClasses,
    ref: ref
  }), draggable && /*#__PURE__*/_react.default.createElement("span", {
    "aria-live": "polite",
    className: classnames(`${CSS_BLOCK}__screen-reader-only`),
    id: instructionsId
  }, draggable.screenReaderInstructions), customBackAction ? /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__action-title`)
  }, customBackAction, _renderChildren(children)) : _renderChildren(children), !draggable && closeButtonToRender), draggable && closeButtonToRender);
});
const propTypes = {
  /** Content of the modal header. */
  children: _propTypes.default.any,
  /** Custom classes to add to the header's `<div>` tag. */
  className: _propTypes.default.string,
  /** If true, the modal will display a close button. */
  closeButton: _propTypes.default.bool,
  // TODO: figure out how to use JSDoc on custom prop type validators
  // eslint-disable-next-line valid-jsdoc
  /** Provides an accessible label for the close button. Required when `closeButton` is true. */
  // eslint-disable-next-line consistent-return
  closeLabel: (props, propName, componentName) => {
    if (props.closeButton && (!props[propName] || typeof props[propName] !== 'string')) {
      return new Error(`The prop ${propName} is required in ${componentName} when \`closeButton\` is true. ${(0, _messages.LOCALIZED_TEXT_MESSAGE)('CoreUIComponents.close')}`);
    }
  },
  /** Custom action/button to be rendered to the left of the modal title
   * for actions like 'back'. */
  customBackAction: _propTypes.default.node,
  /** Custom action/button to be rendered instead of the default close button. */
  customCloseAction: _propTypes.default.node,
  /** @ignore */
  containerRef: _propTypes.default.object,
  /** @ignore */
  draggable: _propTypes.default.shape({
    screenReaderInstructions: _propTypes.default.string.isRequired,
    onDragStart: _propTypes.default.func,
    onDragEnd: _propTypes.default.func,
    onKeyDown: _propTypes.default.func
  }),
  /** @ignore */
  subheadId: _propTypes.default.string,
  /** @ignore */
  titleId: _propTypes.default.string,
  /** @ignore */
  updateStyle: _propTypes.default.func,
  /** @ignore */
  modalContentId: _propTypes.default.string,
  /** @ignore Fired when the modal is dismissed. Set by Modal when this is a direct child. */
  onHide: _propTypes.default.func
};
ModalHeader.displayName = 'Modal.Header';
ModalHeader.propTypes = propTypes;
var _default = exports.default = ModalHeader;